var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "newsletter-management-container" },
    [
      _c("Hint", {
        attrs: {
          label: `${_vm.$t("controlPanel.landingPage.newsletterLabel")}`,
          hint: `${_vm.$t("controlPanel.landingPage.newsletterTip")}`
        }
      }),
      _c(
        "draggable",
        {
          staticClass: "draggable-container",
          attrs: { group: "people" },
          on: {
            start: function($event) {
              _vm.drag = true
            },
            end: function($event) {
              _vm.drag = false
            }
          },
          model: {
            value: _vm.newsletters,
            callback: function($$v) {
              _vm.newsletters = $$v
            },
            expression: "newsletters"
          }
        },
        _vm._l(_vm.newsletters, function(newsletter) {
          return _c(
            "div",
            { key: newsletter.order, staticClass: "newsletter-wrapper" },
            [
              _c("NewsletterTemplate", { attrs: { newsletter: newsletter } }),
              _c(
                "div",
                { staticClass: "newsletter-buttons" },
                [
                  _c("IconTooltip", {
                    attrs: {
                      imageName: "edit-green.svg",
                      hoverText: `${_vm.$t(
                        "controlPanel.landingPage.buttons.edit"
                      )}`,
                      iconWidth: "30px",
                      iconClick: event => _vm.editNewsletter(event, newsletter)
                    }
                  }),
                  _c("IconTooltip", {
                    attrs: {
                      imageName: "delete.svg",
                      hoverText: `${_vm.$t(
                        "controlPanel.landingPage.buttons.delete"
                      )}`,
                      iconWidth: "25px",
                      iconClick: event =>
                        _vm.deleteNewsletter(event, newsletter)
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "management-newsletter-buttons" },
        [
          _c(
            "button",
            { staticClass: "management-button", on: { click: _vm.saveOrder } },
            [
              _vm._v(
                _vm._s(_vm.$t("controlPanel.landingPage.buttons.saveOrder")) +
                  " "
              )
            ]
          ),
          _c("IconTooltip", {
            attrs: {
              imageName: "plus-in-circle.svg",
              hoverText: `${_vm.$t("controlPanel.landingPage.buttons.create")}`,
              iconWidth: "38px",
              iconClick: _vm.createNewsletter
            }
          })
        ],
        1
      ),
      _c("NewsletterForm", {
        ref: "newsletterModal",
        attrs: { newsletterChange: _vm.newsletterChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }